/* ControlNibObject.js */

"use strict";
const _ = require("lodash");

//

/**
 * This object is a unique object in that it's 'this' pointer will change on
 * the function calls.  The this object will actually become the continuation object
 * for the running NIB.  This will allow the function calls to link back to the continuation
 * object to get the interaction to the UI.
 */
class ControlNibObject {
    constructor(nibAdapter, continuation) {
        this._nibAdapter = nibAdapter;
        this._continuation = continuation;
    }

    /**
     * Install a package into the system.
     * @param repoId
     * @param pkgId
     * @returns {Promise<any>}
     */
    installPkg(repoId, pkgId) {
        let component = this._nibAdapter.findComponentFromContinuation(this._continuation);
        let lln = 0;

        this.logs = [];
        return new Promise((resolve) => {
            this._nibAdapter.hubbyService.packageInstall(
                {
                    orgId: this._nibAdapter.userSession.activeOrganization.id,
                    repoId: repoId,
                    packageId: pkgId,
                },
                {
                    requestHandlers: {
                        Success: (/*results*/) => {
                            // Model as finish object
                            let finishObj = {
                                logs: this.logs,
                            };
                            resolve(finishObj);
                        },
                        Progress: (msg) => {
                            // Model the msg as a jnib log object.
                            let htmlMsg = msg.replace(/ /g, "\u00a0");
                            lln++;
                            let logObj = {
                                lvl: "CHECKPOINT",
                                time: Date.now(),
                                lln: lln,
                                msg: htmlMsg,
                            };
                            this.logs.push(logObj);
                            if (component && _.isFunction(component.updateNIBProgress)) {
                                component.updateNIBProgress({lastLogEventInfo: logObj});
                            }
                        },
                        Failure: (error) => {
                            // model as finishObj
                            let errorMsg = _.get(
                                error,
                                "error.errorMsg",
                                "Failed to install package"
                            );
                            let finishObj = {
                                errorMsg: errorMsg,
                                logs: this.logs,
                            };
                            resolve(finishObj);
                        },
                    },
                }
            );
        });
    }

    /**
     * Export a package into a zip file.
     * @param repoId - Repo Id
     * @param pkgId - Package Id
     * @param name - Name of the zip file
     * @returns {Promise<any>}
     */
    exportPkg(repoId, pkgId, name) {
        let component = this._nibAdapter.findComponentFromContinuation(this._continuation);
        let lln = 0;
        this.logs = [];
        return new Promise((resolve) => {
            this._nibAdapter.hubbyService.packageExport(
                {
                    orgId: this._nibAdapter.userSession.activeOrganization.id,
                    repoId: repoId,
                    packageId: pkgId,
                },
                {
                    requestHandlers: {
                        Success: (results) => {
                            let fileName = name + "_pkg";
                            this._nibAdapter.fileFactory
                                .saveStringsAsZip(results.pkgContent, fileName)
                                .then(() => {
                                    let finishObj = {
                                        logs: this.logs,
                                    };
                                    resolve(finishObj);
                                });
                            // Model as finish object
                        },
                        Progress: (msg) => {
                            // Model the msg as a jnib log object.
                            lln++;
                            let logObj = {
                                lvl: "CHECKPOINT",
                                time: Date.now(),
                                lln: lln,
                                msg: msg,
                            };
                            this.logs.push(logObj);
                            if (component && _.isFunction(component.updateNIBProgress)) {
                                component.updateNIBProgress({lastLogEventInfo: logObj});
                            }
                        },
                        Failure: (error) => {
                            // model as finishObj
                            let errorMsg = _.get(
                                error,
                                "error.errorMsg",
                                "Failed to export package"
                            );
                            let finishObj = {
                                errorMsg: errorMsg,
                                logs: this.logs,
                            };
                            resolve(finishObj);
                        },
                    },
                }
            );
        });
    }
}

module.exports = ControlNibObject;
